<br>

<div style="width: auto; overflow: auto">
    <app-common-list-table
            [request]="getRequest"
            [cols]="cols"
            [filtering]="filtering"
            [globalConditionalStyle]="globalConditionalStyle"
            [globalVisualTransform]="globalVisualTransform.bind(this)"
            [showExportCsv]="showCostesTareasFertiCsv"
            (emitSearchText)="updateFooter()">

            <ng-template #header let-data>
                <div 
                    style="width: 100%; margin-right: 15px" 
                    class="d-flex justify-content-center align-items-center" 
                    *ngIf="appName === 'detorres'">
                    <div style="margin-left: 10px; margin-right: 10px">
                        <div style="font-size: 0.7em" class="btn-group">
                            <button 
                                type="button" 
                                class="btn btn-info" 
                                style="padding: 5px; font-size: .8rem; border: none; background-color: #16A2B7; color: white; width: 10rem;"
                                (click)="generateProductsReport()">Informe Productos</button>
                        </div>
                    </div>
                </div>
            </ng-template>
        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center"
                   style="margin-bottom: 0">Acciones</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <app-action-buttons
                    [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                    [hideEdit]="true" 
                    [hideDelete]="true"
                    (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        </ng-template>

        <ng-template #footer let-col>
            <div style="font-size: 0.75em; text-align: left" *ngIf="(['apellidos'].includes(col.field))">
                TOTAL:
            </div>
            <div style="font-size: 0.75em; text-align: right; font-weight: bold"
                 *ngIf="(['resultado'].includes(col.field))">
                {{moneyFormat(col.footer)}} €
            </div>
        </ng-template>

    </app-common-list-table>
</div>

<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>
